import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { DEPRECATED_QUERY_KEYS, queryClient } from '@src/query';
import { CollectionView } from 'common';
import { getCollections } from './api';
import { useAuthEnabled } from '@src/hooks/useAuthStatus';

/**
 * Find collections on which the user has viewer rights
 */
export const useQueryCollections = (config?: Omit<UseQueryOptions<CollectionView[]>, 'queryKey' | 'queryFn'>) => {
  const authEnabled = useAuthEnabled();
  const enabled = authEnabled && (config?.enabled ?? true);

  return useQuery({
    queryKey: [DEPRECATED_QUERY_KEYS.COLLECTIONS],
    queryFn: queryCollections,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnReconnect: 'always',
    refetchOnWindowFocus: true,
    retry: 2,
    ...config,
    enabled,
  });
};

export const queryCollections = async () => {
  const collections = await getCollections();
  return collections.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
};

export const setQueryCollections = (collections: CollectionView[]) => {
  queryClient.setQueryData([DEPRECATED_QUERY_KEYS.COLLECTIONS], collections);
};
